import { CalendarEntry, LinkedCalendarEntry } from 'owa-graph-schema';
import {
    CalendarId,
    getCalendarEntryByCalendarId,
    getCalendarEntryByFolderId,
} from 'owa-calendar-cache';

import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import CalendarFolderTypeEnum from 'owa-service/lib/contract/CalendarFolderTypeEnum';
import { isEventAMeeting } from 'owa-calendar-event-capabilities';
import { isLinkedCalendarEntry } from 'owa-calendar-properties';

/**
 * Returns if the meeting is not on primary calendar.
 * If item represents an appointment, then it returns false.
 * @param event calendar event object
 */
export default function isMeetingOnSecondaryCalendar(event: CalendarEvent): boolean {
    return event && isEventAMeeting(event) && !isOnPrimaryCalendar(event);
}

/**
 * Gets whether the current item is on a primary calendar folder
 * @param item calendar item object
 */
export const isOnPrimaryCalendar = (event: CalendarEvent): boolean => {
    if (event) {
        let calendarEntry = getCalendarEntryByFolderId(event.ParentFolderId.Id);
        return isPrimaryCalendarEntry(calendarEntry);
    }

    return false;
};

export const isPrimaryCalendarId = (calendarId: CalendarId): boolean => {
    if (calendarId) {
        let calendarEntry = getCalendarEntryByCalendarId(calendarId.id);
        return isPrimaryCalendarEntry(calendarEntry);
    }

    return false;
};

function isPrimaryCalendarEntry(calendarEntry: CalendarEntry): boolean {
    if (calendarEntry) {
        return (
            calendarEntry.CalendarFolderType == CalendarFolderTypeEnum.DefaultCalendar ||
            (isLinkedCalendarEntry(calendarEntry) &&
                (calendarEntry as LinkedCalendarEntry).IsGeneralScheduleCalendar)
        );
    }

    return false;
}
